import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import ListaClientes from "../../Componentes/ListaClientes";
import { useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import "./styles.css";

const Menu = () => {
  const { resetaVariaveis } = usePentagovContext();
  const { isAuthenticated, authReady, } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const navigate = useNavigate();
  const [Clientes, setClientes] = useState([]);

  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(() => {
    if (operador && operador.IDOperador && isAuthenticated && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, [operador]);


  async function inicializaTela() {
    resetaVariaveis();
    let retorno = await buscaClientes(IDOperador);
    console.log(retorno);
    if (retorno && retorno.data && Array.isArray(retorno.data.Clientes)) {
      setClientes(retorno.data.Clientes);
    } else {
      console.warn("Clientes não encontrados ou estrutura inesperada:", retorno.data);
      setClientes([]);
    }
  }


  async function buscaClientes(IDoperador) {
    try {
      const response = await api.get('/clientes/operador/' + IDoperador);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>CLIENTES</h4>

        <ListaClientes lista={Clientes || []} />

      </div>
    </div>

  );
};

export default Menu;